// Custom lazy load
function aboutPagev2() {

    if ( !$('div.aboutv2').length ) {
        return;
    }

    var hashAdjust = '';
    var scrollerfn = '';

    $('.about-nav a').anchorAnimate();
    $('section.stats h3').one('inview', function(event, isInView) {
        statsCount();
    });
    $('section.stats .inner').on('click', function(){
        statsCount();
    });

    $('section.stats').one('inview', function(event, isInView) {
        $('section.stats p.stat').fadeTo(10,0);
    });

    function statsCount() {
        $('div.aboutv2 section.stats p.stat strong').each(function(index){
            var el = $(this);
            el.html('0');
            el.parent().fadeTo(300, 1);
            el.countTo({
                from: 0,
                to:  el.data('count'),
                speed: 2000,//(1000 * (index + 1)) + 500,
                refreshInterval: 30,
                formatter: function (value, options) {
                    value = value.toFixed(options.decimals);
                    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    return value;
                }
            });
        });
    }

    function scroller() {
        $('section.section.inview').removeClass('inview');
        var inview = $('section.section:in-viewport:first').find('.anchor>a').attr('id');
        $('section.section:in-viewport:first').addClass('inview');
        $('.about-nav>ul>li.active').removeClass('active');
        $(`a[href="#${inview}"]`).parent().addClass('active');
        //hashControl();
    }

    function hashControl() {
        clearTimeout(hashAdjust);
        if ($(window).scrollTop() < 50) {
            var hashAdjust = setTimeout(function() {
                if (history.pushState) {
                    history.pushState({}, '', window.location.pathname);
                }
                $('div.about-nav li.active').removeClass('inview');
            }, 100);
        } else {
            var hashAdjust = setTimeout(function() {
                if (history.pushState) {
                    history.pushState({}, '', $('div.about-nav li.active>a').attr('href'));
                }
            }, 100);
        }
    }

    $(window).on('scroll', function() {
        clearTimeout(scrollerfn);
        scrollerfn = setTimeout(scroller, 100);
    });

    scroller();

    // If hash exists, click the hash's relevant link
    if(window.location.hash) {
        window.scrollTo(0, 0);
        setTimeout(function() {
            window.scrollTo(0, 0);
        }, 1);
        setTimeout(function() {
            $(`a[href="${window.location.hash}"]`).trigger('click');
        }, 100);
    }

    setTimeout(function() {
        AOS.init();
    }, 500);

    window.addEventListener('scroll', function(){
        return;
        var scrollPosition = window.pageYOffset;
        var bgParallax = document.getElementsByClassName('bganim')[0];
        var limit = bgParallax.offsetTop + bgParallax.offsetHeight;
        if (scrollPosition > bgParallax.offsetTop && scrollPosition <= limit){
            bgParallax.style.backgroundPositionY = (50 - 100*scrollPosition/limit) + '%';
        } else {
            bgParallax.style.backgroundPositionY = '50%';
        }
        log('yes');
    });



    var swiper = new Swiper('section.testimonials .swiper-container', {
        grabCursor: true,
        centeredSlides: true,
        scrollbarHide: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        slidesPerView: 1,
        grabCursor: true,
        autoplayDisableOnInteraction: true,
        mousewheelControl: false,
        mousewheelReleaseOnEdges: true,
        mousewheelForceToAxis: false,
        mousewheelSensitivity: 1,
        spaceBetween: 50,
        autoheight: false,
        autoplay: {
            delay: 8500
        },
        pagination: {
            el: 'section.testimonials .swiper-pagination',
        },
        navigation: {
            nextEl: 'section.testimonials .next',
            prevEl: 'section.testimonials .prev',
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true
        }
    });

    var swiper = new Swiper('section.moments .swiper-container', {
        grabCursor: true,
        centeredSlides: true,
        navigation: {
            nextEl: 'section.moments .next',
            prevEl: 'section.moments .prev',
        },
        pagination: '#moments .sg-pager',
        paginationType: 'progress',
        scrollbarHide: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        slidesPerView: 'auto',
        grabCursor: true,
        autoplayDisableOnInteraction: true,
        paginationClickable: true,
        mousewheelControl: false,
        mousewheelReleaseOnEdges: true,
        mousewheelForceToAxis: false,
        mousewheelSensitivity: 1,
        spaceBetween: 50,
        autoplay: false,keyboard: {
            enabled: true,
            onlyInViewport: true
        }
    });

}
